import React from 'react'
import {
 Navigate,
 useLocation,
 useParams,
} from 'react-router-dom'
import AddProductPageWrapper from './AddProduct'
import {getProductCataloguePath} from './productCatalogueRoutes'

type ProductDetailsLocationState = {
 returnPath?: string
}

const ProductDetailsPage = () => {
 const {productId} = useParams<{productId: string}>()
 const location = useLocation()
 const navigationState =
  (location.state as ProductDetailsLocationState | null) ??
  {}

 if (!productId || !/^\d+$/.test(productId)) {
  return <Navigate to={getProductCataloguePath()} replace />
 }

 return (
  <div className='container relative'>
   <div className='px-[72px] pt-6 pb-10 bg-white'>
    <AddProductPageWrapper
     selectedProductId={Number(productId)}
     returnPath={
      navigationState.returnPath ??
      getProductCataloguePath()
     }
    />
   </div>
  </div>
 )
}

export default ProductDetailsPage
